export function ToggleSwitch({ value, onChange }: { value: boolean; onChange: (v: boolean) => void }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!value)}
      className="relative w-9 h-5 rounded-full cursor-pointer transition-all duration-200 flex-shrink-0"
      style={
        value
          ? { background: '#f97316', border: '1px solid #f97316', boxShadow: '0 0 10px rgba(249,115,22,0.3)' }
          : { background: 'var(--theme-border-2)', border: '1px solid var(--theme-border-2)' }
      }
    >
      <span
        className={`absolute top-[2px] w-3.5 h-3.5 rounded-full bg-white transition-all duration-200 ${
          value ? 'left-[18px]' : 'left-[2px]'
        }`}
        style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.15)' }}
      />
    </button>
  );
}
